export const STUDY_FLOW_V1 = "study_flow_v1";
export const STUDY_FLOW_V2 = "study_flow_v2_common_btrt_diva";

const FLOW_V1 = Object.freeze({
  branch: "pilot/study-v1-default",
  steps: Object.freeze([
    "consent",
    "demographics",
    "movies",
    "wmtIntro",
    "wmtPractice",
    "wmtTest",
    "pairwise",
    "finalComparisonIntro",
    "externalComparisons",
    "thankYou",
  ]),
  next: Object.freeze({
    consent: "demographics",
    demographics: "movies",
    movies: "wmtIntro",
    wmtIntro: "wmtPractice",
    wmtPractice: "wmtTest",
    wmtTest: "pairwise",
    pairwise: "finalComparisonIntro",
    finalComparisonIntro: "externalComparisons",
    externalComparisons: "thankYou",
  }),
  saveCompletionMarker: true,
});

const FLOW_V2 = Object.freeze({
  branch: "pilot/study-v2-common-btrt-diva",
  steps: Object.freeze([
    "consent", "demographics", "movies", "wmtIntro", "wmtPractice", "wmtTest",
    "commonBtrt", "commonInformedness", "commonDivaRanking", "pairwise", "recommendationComparison", "thankYou",
  ]),
  next: Object.freeze({
    ...FLOW_V1.next,
    wmtTest: "commonBtrt",
    commonBtrt: "commonInformedness",
    commonInformedness: "commonDivaRanking",
    commonDivaRanking: "pairwise",
    pairwise: "recommendationComparison",
  }),
  saveCompletionMarker: true,
});

export const STUDY_FLOWS = Object.freeze({ [STUDY_FLOW_V1]: FLOW_V1, [STUDY_FLOW_V2]: FLOW_V2 });
// Compatibility export: callers that have not resolved a persisted version remain on v1.
export const STUDY_FLOW = FLOW_V1;
export const PILOT_START_STEP = FLOW_V1.steps[0];

export function getStudyFlow(version) {
  return STUDY_FLOWS[version] ?? FLOW_V1;
}

export function isPilotStep(step) {
  return Object.values(STUDY_FLOWS).some((flow) => flow.steps.includes(step));
}
